// Pure helpers for AdminShell — extracted for unit testing.
// Rendering logic lives in AdminShell.js / AdminSidebar.js / AdminTabBar.js
// which are tested via Playwright e2e.

import { ADMIN_NAV_ITEMS } from '@/config/adminNav'

// Match the deepest nav item whose href is a prefix of the current pathname.
// Returns null if pathname doesn't start with /admin or no match found.
export function resolveActiveNavId(pathname) {
  if (!pathname || !pathname.startsWith('/admin')) return null

  // Exact dashboard match
  if (pathname === '/admin') return 'dashboard'

  // Find longest matching prefix among non-dashboard items
  let best = null
  let bestLen = 0
  for (const item of ADMIN_NAV_ITEMS) {
    if (item.href === '/admin') continue // dashboard excluded from prefix match
    if (pathname === item.href || pathname.startsWith(item.href + '/')) {
      if (item.href.length > bestLen) {
        best = item.id
        bestLen = item.href.length
      }
    }
  }
  return best
}

/**
 * Returns whether the sidebar should be visible at a given viewport width.
 *
 * NOTE: This function is NOT used at runtime for rendering. Sidebar visibility
 * is controlled purely by CSS media queries in admin.css (`.admin-sidebar`
 * `display: none` on mobile, `display: flex` ≥ 768px). This helper exists only
 * to assert that CSS breakpoint logic matches between the source-of-truth
 * (this function) and E2E / unit test expectations. If runtime width detection
 * is ever needed (e.g. conditional rendering based on viewport), use this
 * function for consistency.
 *
 * @param {number} viewportWidth - CSS pixel width of the viewport.
 * @returns {boolean} true if sidebar should be visible (≥ 768px).
 */
export function shouldShowSidebar(viewportWidth) {
  return viewportWidth >= 768
}
